import RaphaelSvg from'../vendors/redraphael/source/raphael.svg';export default{extension:function(a){RaphaelSvg(a.getDep('redraphael','plugin'))},name:'redraphaelSvg',type:'plugin',requiresFusionCharts:!0};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-core/src/_internal/redraphael/redraphael.svg.js
// module id = null
// module chunks = 